import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import bridgechefABI from 'config/abi/bridgeChef.json'
import multicall from 'utils/multicall'
import { getAddress, getBridgeChefAddress } from 'utils/addressHelpers'
import { FarmConfig } from 'config/constants/types'
import { ChainId } from '../../config/constants/chainId'
import { getRpcProvider } from '../../utils/providers'

export const fetchFarmUserAllowances = async (account: string, farmsToFetch: FarmConfig[], chainId: ChainId) => {
  const bridgeChefAddress = getBridgeChefAddress(chainId)

  const calls = farmsToFetch.map((farm) => {
    const lpContractAddress = getAddress(farm.lpToken.address, chainId)
    return { address: lpContractAddress, name: 'allowance', params: [account, bridgeChefAddress] }
  })

  const defaultSigner = await getRpcProvider(chainId)
  const rawLpAllowances = await multicall(erc20ABI, calls, chainId, defaultSigner)
  const parsedLpAllowances = rawLpAllowances.map((lpBalance) => {
    return new BigNumber(lpBalance).toJSON()
  })
  return parsedLpAllowances
}

export const fetchFarmUserTokenBalances = async (account: string, farmsToFetch: FarmConfig[], chainId: ChainId) => {
  const calls = farmsToFetch.map((farm) => {
    const lpContractAddress = getAddress(farm.lpToken.address, chainId)
    return {
      address: lpContractAddress,
      name: 'balanceOf',
      params: [account],
    }
  })

  const defaultSigner = await getRpcProvider(chainId)
  const rawTokenBalances = await multicall(erc20ABI, calls, chainId, defaultSigner)
  const parsedTokenBalances = rawTokenBalances.map((tokenBalance) => {
    return new BigNumber(tokenBalance).toJSON()
  })
  return parsedTokenBalances
}

export const fetchFarmUserStakedBalances = async (account: string, farmsToFetch: FarmConfig[], chainId: ChainId) => {
  const bridgeChefAddress = getBridgeChefAddress(chainId)

  const calls = farmsToFetch.map((farm) => {
    return {
      address: bridgeChefAddress,
      name: 'depositInfo',
      params: [farm.farmId, account],
    }
  })

  const defaultSigner = await getRpcProvider(chainId)
  const rawStakedBalances = await multicall(bridgechefABI, calls, chainId, defaultSigner)
  const parsedStakedBalances = rawStakedBalances.map((stakedBalance) => {
    return new BigNumber(stakedBalance[0]._hex).toJSON()
  })
  return parsedStakedBalances
}

export const fetchFarmUserEarnings = async (account: string, farmsToFetch: FarmConfig[], chainId: ChainId) => {
  const bridgeChefAddress = getBridgeChefAddress(chainId)

  const calls = farmsToFetch.map((farm) => {
    return {
      address: bridgeChefAddress,
      name: 'bridgeTokensReadyToHarvest',
      params: [farm.farmId, account],
    }
  })

  const defaultSigner = await getRpcProvider(chainId)
  const rawEarnings = await multicall(bridgechefABI, calls, chainId, defaultSigner)
  const parsedEarnings = rawEarnings.map((earnings) => {
    return new BigNumber(earnings).toJSON()
  })
  return parsedEarnings
}
